import { INBOX_TYPES } from 'shared/mixins/inboxMixin';

export const getInboxSource = (type, phoneNumber, inbox) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return inbox.website_url || '';

    case INBOX_TYPES.TWILIO:
    case INBOX_TYPES.WHATSAPP:
      return phoneNumber || '';

    case INBOX_TYPES.EMAIL:
      return inbox.email || '';

    default:
      return '';
  }
};
export const getReadableInboxByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'livechat';

    case INBOX_TYPES.FB:
      return 'facebook';

    case INBOX_TYPES.TWITTER:
      return 'twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp') ? 'whatsapp' : 'sms';

    case INBOX_TYPES.WHATSAPP:
      return 'whatsapp';

    case INBOX_TYPES.API:
      return 'api';

    case INBOX_TYPES.EMAIL:
      return 'email';

    case INBOX_TYPES.TELEGRAM:
      return 'telegram';

    case INBOX_TYPES.LINE:
      return 'line';

    default:
      return 'chat';
  }
};

export const getInboxClassByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'globe-desktop';

    case INBOX_TYPES.FB:
      return 'brand-facebook';

    case INBOX_TYPES.TWITTER:
      return 'brand-twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp')
        ? 'brand-whatsapp'
        : 'brand-sms';

    case INBOX_TYPES.WHATSAPP:
      return 'brand-whatsapp';

    case INBOX_TYPES.API:
      return 'cloud';

    case INBOX_TYPES.EMAIL:
      return 'mail';

    case INBOX_TYPES.TELEGRAM:
      return 'brand-telegram';

    case INBOX_TYPES.LINE:
      return 'brand-line';

    default:
      return 'chat';
  }
};

export const getInboxWarningIconClass = (type, reauthorizationRequired) => {
  const allowedInboxTypes = [INBOX_TYPES.FB, INBOX_TYPES.EMAIL];
  if (allowedInboxTypes.includes(type) && reauthorizationRequired) {
    return 'warning';
  }
  return '';
};

// Marcador da caixa de teste, recomposto na exibicao.
//
// O prefixo "Teste · " e gravado no NOME da inbox na criacao
// (ai_agent/test_conversation_service.rb). Sendo dado, ele nao acompanha a
// troca de idioma -- quem exibe e que precisa recompor. Aqui o prefixo gravado
// sai e o traduzido entra, entao a mesma caixa le "Teste · Vera",
// "Test · Vera" ou "Prueba · Vera" conforme o idioma escolhido, sem tocar no
// banco e valendo tambem para as caixas que ja existem.
const SANDBOX_STORED_PREFIX = /^\s*teste\s*·\s*/i;

export const inboxDisplayName = (inbox, sandboxLabel) => {
  const name = String(inbox?.name || '').trim();

  // Sem nome nao ha o que marcar: o marcador sozinho sairia como "Teste · ",
  // um separador apontando para o nada.
  if (!name) return name;

  if (!inbox?.sandbox || !sandboxLabel) return name;

  // O marcador entra sempre, mesmo quando o agente se chama "Teste" e em
  // pt-BR o resultado fica "Teste · Teste". Suprimir a repeticao economizava
  // uma palavra mas escondia de qual agente e a caixa, e so em pt-BR --
  // nos outros idiomas nao ha choque. Melhor a mesma leitura em todo idioma.
  const base = name.replace(SANDBOX_STORED_PREFIX, '').trim() || name;

  return `${sandboxLabel} · ${base}`;
};
